import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaThumbsUp, FaThumbsDown, FaEye, FaEyeSlash, FaPlane, FaPlaneDeparture, FaPlaneArrival, FaTrash, FaUser, FaMapMarkerAlt, FaBed, FaPlane as FaPlaneIcon, FaFileAlt, FaHistory, FaColumns, FaBus, FaSync, FaExclamationTriangle } from 'react-icons/fa';
import { RiMailSendLine } from 'react-icons/ri';
import api from '../../../services/api';
import ModalForcarEnvio from '../../../components/ModalForcarEnvio';
import { useCartaFila, BadgeCartaFila, PERFIS_FILA } from '../../../components/CartaFilaStatus';
import { useHistory, useLocation } from 'react-router-dom';
import { dataMysql, buscarCep, extract, data, hora, dataHoraMysql, dataHora, getOpcaoIda, idaCompleta, retornoCompleto, getOpcaoRetorno, compareIda, compareRetorno, idaTemDados, retornoTemDados, formatCrm, isTipoHcp, isNaoFarmaceutico, isEventoAmbos, categoriaTiposParticipante, CARGO_OUTROS, CATEGORIA_NAO_FARMACEUTICO } from '../../../util/util';
import { getInternalAuth } from '../../../util/authSession';
import Data from '../../../components/Data';
import FormButton from '../../../components/FormButton';
import ReactSelect from '../../../components/ReactSelect';
import Alert from '../../../components/Alert';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import TabelaHistoricoParticipante from '../../../components/TabelaHistoricoParticipante';
import VisualizarArquivoModal from '../../../components/VisualizarArquivoModal';
import { FinField, FinInput, FinTextarea, FinCheck, FinChecks } from '../../../components/FinField';
import LocalAereo from '../../../components/LocalAereo';
import '../../../css/financeiro-parcela-pagar.css';

const OPCOES_UF = [
    { value: "AC", label: "AC" },
    { value: "AL", label: "AL" },
    { value: "AP", label: "AP" },
    { value: "AM", label: "AM" },
    { value: "BA", label: "BA" },
    { value: "CE", label: "CE" },
    { value: "DF", label: "DF" },
    { value: "ES", label: "ES" },
    { value: "GO", label: "GO" },
    { value: "MA", label: "MA" },
    { value: "MT", label: "MT" },
    { value: "MS", label: "MS" },
    { value: "MG", label: "MG" },
    { value: "PA", label: "PA" },
    { value: "PB", label: "PB" },
    { value: "PR", label: "PR" },
    { value: "PE", label: "PE" },
    { value: "PI", label: "PI" },
    { value: "RJ", label: "RJ" },
    { value: "RN", label: "RN" },
    { value: "RS", label: "RS" },
    { value: "RO", label: "RO" },
    { value: "RR", label: "RR" },
    { value: "SC", label: "SC" },
    { value: "SP", label: "SP" },
    { value: "SE", label: "SE" },
    { value: "TO", label: "TO" },
];

const OPCOES_SIM_NAO_CLD = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
    { value: 'cld', label: 'Cancelado' },
];

const OPCOES_SIM_NAO = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
];

const OPCOES_PRESENTE = [
    { value: 'nulo', label: 'Sem registro' },
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
];

export default function CadastroEventoParticipante({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');

    // Modal de envio imediato: aberto quando o back recusa por a carta ja estar na fila.
    const [forcarEnvio, setForcarEnvio] = useState({ show: false, mensagem: '', reenviar: null });



    /**
     * Dispara a informativa deste participante.
     *
     * Dois avisos, sempre nesta ordem e nunca no mesmo passo:
     *
     *   1. dados faltantes / reenvio - pre-checagem do back, que e fail-all: nada saiu
     *      ainda. Confirmar repete a chamada com `confirmarEnvio`.
     *   2. carta ja enfileirada - modal de bypass da fila, o ultimo antes de sair.
     *      Confirmar repete com `forcarEnvio`.
     *
     * As flags sao cumulativas de proposito: forcar a fila depois de ja ter confirmado
     * dados faltantes precisa mandar as duas, senao a pre-checagem barra de novo e o
     * operador volta ao inicio do fluxo.
     *
     * Cada aviso sai por um `return`: enquanto ha o que confirmar nao ha desfecho para
     * anunciar, e o toast de sucesso diria que a carta entrou na fila antes de entrar.
     */
    const enviarInformativaRequest = (idParticipante, { confirmar = false, forcar = false } = {}) => {
        api({
            method: 'post',
            action: '/eventoCarta/enviarCartaInformativa',
            token: token,
            data: {
                idParticipantes: idParticipante,
                confirmarEnvio: confirmar,
                forcarEnvio: forcar,
            },
        })
            .then(function (response) {
                const d = response.data.data;

                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (d.quantidadeSucesso === undefined && d.mensagem) {
                    toast.error(d.mensagem);
                    return;
                }

                const errosIncompletos = (d.erros ?? []).filter(e => e.tipo === 'rsvp_incompleto');
                const errosReenvio = (d.erros ?? []).filter(e => e.tipo === 'reenvio');
                const outrosErros = (d.erros ?? []).filter(e => !['rsvp_incompleto', 'reenvio'].includes(e.tipo));

                if (errosIncompletos.length > 0 || errosReenvio.length > 0) {
                    //o html do Alert vai pra innerHTML: nome de participante e digitado pelo usuario
                    const esc = (valor) => String(valor ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
                    const blocos = errosIncompletos.map(e => {
                        const grupos = e.campos_faltantes ?? {};
                        const bullets = Object.keys(grupos)
                            .map(g => `<li><strong>${esc(g)}:</strong> ${(grupos[g] ?? []).map(esc).join(', ')}</li>`)
                            .join('');
                        return `<div style="margin-bottom:8px;text-align:left"><strong style="color:#333;display:block;margin-bottom:2px;text-align:center">Participante ${esc(e.participante)}:</strong><ul style="text-align:left;margin:4px 0 0;padding-left:18px">${bullets}</ul></div>`;
                    }).join('');
                    const blocosReenvio = errosReenvio
                        .map(e => `<li><strong>${esc(e.participante)}</strong> — enviada em ${esc(e.enviadaem)}</li>`)
                        .join('');
                    // Havendo reenvio, a confirmação fala de reenvio mesmo que haja dados faltantes
                    // junto — senão o operador confirma achando que é o primeiro envio.
                    const temReenvio = errosReenvio.length > 0;
                    const soReenvio = temReenvio && errosIncompletos.length === 0;
                    const rotuloConfirmar = temReenvio ? 'Reenviar mesmo assim.' : 'Enviar mesmo assim.';

                    Alert({
                        icon: "warning",
                        title: soReenvio ? "Reenvio de Carta Informativa" : (temReenvio ? "Confirme o envio" : "Dados incompletos no cadastro"),
                        html: (errosIncompletos.length > 0
                            ? `A Carta Informativa possui dados faltantes:<br><br>${blocos}`
                            : '')
                            + (errosReenvio.length > 0
                                ? `<p style="margin:8px 0 4px;text-align:left">Já recebeu a Carta Informativa:</p>`
                                + `<ul style="text-align:left;margin:4px 0 0;padding-left:18px">${blocosReenvio}</ul>`
                                : '')
                            + `<hr style="margin:12px 0" />`
                            + `<h5 style="color:#e74c3c;margin:0 0 6px;text-align:left">Atenção:</h5>`
                            + `<p style="margin:0 0 8px;text-align:left">Nenhum e-mail foi enviado ainda. Confirme o envio da carta informativa:</p>`,
                        input: "checkbox",
                        inputPlaceholder: rotuloConfirmar,
                        inputValidator: (value) => {
                            if (!value) {
                                return `Marque "${rotuloConfirmar}" para confirmar o envio.`;
                            }
                        },
                        confirmButton: temReenvio ? "Confirmar reenvio" : "Confirmar envio",
                        cancelButton: "Cancelar",
                        callBack: (resultado) => {
                            if (resultado.isConfirmed && resultado.value) {
                                enviarInformativaRequest(idParticipante, { confirmar: true, forcar: forcar });
                            }
                        },
                    });

                    return;
                }

                if (d.podeForcar) {
                    setForcarEnvio({
                        show: true,
                        mensagem: d.mensagem,
                        reenviar: () => enviarInformativaRequest(idParticipante, { confirmar: confirmar, forcar: true }),
                    });

                    return;
                }

                if (d.quantidadeSucesso > 0 || d.enfileirados > 0 || d.jaNaFila > 0) {
                    // Entrou na fila, ainda nao saiu - o texto vem do back para nao haver duas versoes.
                    toast.success(d.mensagem);
                    buscar();
                    // A carta acabou de entrar na fila deste evento. Sem isto o hook so
                    // consultaria de novo se `emAndamento` ja fosse true — e com a fila vazia
                    // na abertura da tela ele consulta uma vez e para, entao a marca do topo
                    // nunca apareceria justamente para a carta que o operador mandou aqui.
                    // O envio acabou de recarregar os dados desta tela: a marca vai sumir no proximo
                    // poll e a transicao dispararia o banner "a tela mostra os valores de antes"
                    // segundos depois de ela ter sido atualizada. Zera a sentinela antes.
                    tinhaCartaNaFila.current = 0;
                    setCartaSaiuDaFila(false);
                    recarregarFila();
                }

                outrosErros.forEach(function (erro) {
                    if (erro.mensagem) {
                        toast.error(erro.mensagem);
                    }
                });
            })
            .catch(function (error) {
                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
            });
    };

    /** Confirmacao inicial do botao Enviar Informativa. */
    const enviarInformativa = () => {
        Alert({
            icon: "question",
            confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
            denyButton: <><FaThumbsDown size={20} /> Sair</>,
            title: "Enviar Carta Informativa?",
            callBack: (result) => {
                if (result.isConfirmed) {
                    enviarInformativaRequest(id);
                }
            },
        });
    };

    /**
     * Dispara o convite deste participante. Envio individual sai no mesmo request; se ja
     * houver carta enfileirada para ele, o back recusa e devolve `podeForcar`, e a tela
     * oferece o envio imediato em vez de deixar o operador sem saida.
     */
    const enviarConviteRequest = (forcar) => {
        api({
            method: 'post',
            action: '/eventoCarta/enviarCartaConvite',
            token: token,
            data: { idParticipantes: id, forcarEnvio: forcar },
        })
            .then(function (response) {
                const dados = response.data.data;

                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (dados.quantidadeSucesso === undefined && dados.mensagem) {
                    toast.error(dados.mensagem);
                    return;
                }

                if (dados.podeForcar) {
                    setForcarEnvio({ show: true, mensagem: dados.mensagem, reenviar: () => enviarConviteRequest(true) });
                    return;
                }

                if (dados.quantidadeSucesso > 0 || dados.enfileirados > 0 || dados.jaNaFila > 0) {
                    // O texto proprio do aereo so vale quando a carta SAIU. Com lote drenando
                    // no evento, o individual e enfileirado e a resposta traz `enfileirados` —
                    // dizer "enviada" ali faz o operador esperar um e-mail que ainda nao saiu, e
                    // clicar de novo. Nos demais casos vale a regra dos outros tres pontos de
                    // disparo: o texto vem do back, para nao haver duas versoes.
                    toast.success(
                        isSolicitandoNovaOpcaoAereo && dados.quantidadeSucesso > 0 && !dados.enfileirados
                            ? 'Nova opção de aéreo enviada.'
                            : dados.mensagem
                    );
                }
                (dados.erros ?? []).forEach(function (erro) {
                    toast.error(erro.mensagem);
                });
                // O envio carimba datas/situacao no participante e avanca o updated_at:
                // recarrega pra re-sincronizar dados + a trava de concorrencia.
                buscar();
                // A carta acabou de entrar na fila deste evento. Sem isto o hook so
                // consultaria de novo se `emAndamento` ja fosse true — e com a fila vazia
                // na abertura da tela ele consulta uma vez e para, entao a marca do topo
                // nunca apareceria justamente para a carta que o operador mandou aqui.
                // O envio acabou de recarregar os dados desta tela: a marca vai sumir no proximo
                // poll e a transicao dispararia o banner "a tela mostra os valores de antes"
                // segundos depois de ela ter sido atualizada. Zera a sentinela antes.
                tinhaCartaNaFila.current = 0;
                setCartaSaiuDaFila(false);
                recarregarFila();
            })
            .catch(function (error) {
                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
            });
    };
    const SITUACAO_SOLICITA_NOVA_OPCAO_AEREO = '2';
    const SITUACAO_AGUARDANDO_ESCOLHA_AEREO = '177111411651775447';
    const [dados, setDados] = useState({});

    // Carta na fila deste participante: a marca no topo evita que o operador dispare
    // de novo achando que o clique anterior nao saiu.
    //
    // Depois do useState de `dados`, e nao junto do token: `dados` e const, entao le-lo
    // antes da declaracao estoura ReferenceError e derruba a tela no ErrorBoundary.
    // So consulta quem enxerga a marca: para os demais o back recusa e a chamada so serve
    // para pausar o hook.
    const { fila, recarregarFila } = useCartaFila(
        PERFIS_FILA.includes(localStorage.getItem('perfil')) ? dados.evento?.id : null,
        token
    );
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [arquivoPassaporte, setArquivoPassaporte] = useState(null);
    // Loading só na edição (id presente); na criação não há busca, então começa false (evita loading travado).
    const [isLoading, setIsLoading] = useState(!!id);
    // Trava de concorrência: updated_at carregado, para o back barrar escrita sobre dados já alterados por outra pessoa.
    const baseUpdatedAtRef = useRef(null);
    const inputPassaporteRef = useRef(null);
    const [dadosModalHistorico, setDadosModalHistorico] = useState({});
    const [historico, setHistorico] = useState([]);
    const [tableActions, setTableActions] = useState([]);
    const [tableSelect, setTableSelect] = useState({});
    const [anexo, setAnexo] = useState({ convite: false, informativa: false });
    const [verCrmOriginal, setVerCrmOriginal] = useState(false);
    const [previewAnexo, setPreviewAnexo] = useState(null);
    const [tab, setTab] = useState('geral');
    const [eventoAtual, setEventoAtual] = useState(null);
    const history = useHistory();
    const location = useLocation();
    let { state } = location;
    const eventoDaUrl = new URLSearchParams(location.search).get('evento');
    var evento = state?.evento ?? eventoDaUrl ?? null;
    // ramo não farmacêutico: sem CRM/conselho/especialidade, com Cargo.
    // eventoAtual guarda o evento COM o cliente: na edição vem no payload do participante, na criação
    // dados.evento é só o id, então é preciso buscar — senão a tela nova cairia no layout farmacêutico.
    // No evento "Ambos" o ramo segue o tipo escolhido no próprio cadastro.
    const naoFarmaceutico = isNaoFarmaceutico(eventoAtual, dados.tipoparticipante ?? '');
    const categoriaTipos = categoriaTiposParticipante(eventoAtual);
    // evento "Ambos": participante novo escolhe o tipo antes dos demais campos, que dependem do ramo dele
    const escolherTipoPrimeiro = !id && isEventoAmbos(eventoAtual) && !dados.tipoparticipante;
    const cargoEhOutros = String(dados.cargoparticipante ?? '') === CARGO_OUTROS;
    const getSituacaoId = (valor) => {
        if (valor === null || valor === undefined) {
            return '';
        }

        if (['string', 'number', 'boolean', 'bigint'].includes(typeof valor)) {
            return String(valor);
        }

        if (typeof valor === 'object') {
            return getSituacaoId(valor.id ?? valor.situacao ?? '');
        }

        return '';
    };
    const historicoSolicitouNovaOpcaoAereo = historico.some((item) => {
        const situacao = getSituacaoId(item?.situacao);
        const textoHistorico = String(item?.historico ?? '').toLowerCase();

        return situacao === SITUACAO_SOLICITA_NOVA_OPCAO_AEREO
            || textoHistorico.includes('solicitou nova op');
    });
    const situacaoAtualId = getSituacaoId(dados?.situacaoevento);
    const isSolicitandoNovaOpcaoAereo = situacaoAtualId === SITUACAO_SOLICITA_NOVA_OPCAO_AEREO
        || (situacaoAtualId === SITUACAO_AGUARDANDO_ESCOLHA_AEREO && historicoSolicitouNovaOpcaoAereo);
    const tituloAlertaConvite = isSolicitandoNovaOpcaoAereo ? "Enviar nova opção de aéreo?" : "Enviar Carta Convite?";
    const textoBotaoConvite = isSolicitandoNovaOpcaoAereo ? " Enviar nova opção de aéreo" : " Enviar Convite";
    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (!resposta.erro) {
                setDados({
                    ...dadosAtuais,
                    ...{
                        enderecobairro: resposta.bairro,
                        enderecocomplemento: resposta.complemento,
                        enderecologradouro: resposta.logradouro,
                        enderecopais: "30",
                        nomeEnderecopais: "Brasil",
                        enderecomunicipio: resposta.ibge,
                        nomeEnderecomunicipio: resposta.localidade
                    }
                });
            }
        });
    }

    // Modo de CRIAÇÃO: sem `id` a tela nunca busca o participante, então `dados.colunas` não vem
    // do back e a aba Colunas Nomeáveis aparecia vazia mesmo com o evento tendo colunas. Semeia as
    // definições pelo evento (mesmo caminho da Lista de Presença), com valor em branco.
    useEffect(() => {
        if (id || !evento) {
            return;
        }
        api({
            method: 'get',
            action: '/evento/listaPresencaResumo/' + evento,
            token: token,
        })
            .then(response => {
                const definicoes = response.data?.data?.colunas ?? [];
                setDados(dadosAtuais => ({
                    ...dadosAtuais,
                    colunas: definicoes.map(coluna => ({
                        id: coluna.id,
                        ordem: coluna.ordem,
                        nome: coluna.nome,
                        questionar: coluna.questionar,
                        ativo: coluna.ativo,
                        valor: '',
                    })),
                }));
            })
            .catch(() => {
                // sem as definições a aba fica vazia, como antes — não derruba o cadastro
            });
        // eslint-disable-next-line
    }, [id, evento]);

    const buscar = () => {
        if (id) {
            setIsLoading(true);
            api({
                method: "get",
                action: '/participante/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'enderecopais',
                        'aereomunicipioembarque',
                        'enderecomunicipio',
                        'tipoparticipante',
                        'cargoparticipante',
                        'hotelmunicipio',
                        'banco',
                    ]
                });
                evento = dadosRecebidos.evento.id;
                setEventoAtual(dadosRecebidos.evento); //traz o cliente junto (with evento.cliente)
                dadosRecebidos.hoteldatacheckin = data(dadosRecebidos.hoteldatacheckin);
                dadosRecebidos.hoteldatacheckout = data(dadosRecebidos.hoteldatacheckout);
                dadosRecebidos.datanascimento = data(dadosRecebidos.datanascimento);
                dadosRecebidos.dataopcaoaereo = data(dadosRecebidos.dataopcaoaereo);
                dadosRecebidos.horacartainformativa = hora(dadosRecebidos.datacartainformativa);
                dadosRecebidos.datacartainformativa = data(dadosRecebidos.datacartainformativa);
                dadosRecebidos.dataconfirmacaocartainformativa = data(dadosRecebidos.dataconfirmacaocartainformativa);
                dadosRecebidos.horacartaconvite = hora(dadosRecebidos.datacartaconvite);
                dadosRecebidos.datacartaconvite = data(dadosRecebidos.datacartaconvite);
                dadosRecebidos.horacartaassinada = hora(dadosRecebidos.datacartaassinada);
                dadosRecebidos.datacartaassinada = data(dadosRecebidos.datacartaassinada);
                dadosRecebidos.dataconfirmacaodados = data(dadosRecebidos.dataconfirmacaodados);
                dadosRecebidos.horaescolhaaereo = hora(dadosRecebidos.dataescolhaaereo);
                dadosRecebidos.dataescolhaaereo = data(dadosRecebidos.dataescolhaaereo);
                dadosRecebidos.datainscricao = data(dadosRecebidos.datainscricao);
                dadosRecebidos.horacertificado = hora(dadosRecebidos.datacertificado);
                dadosRecebidos.datacertificado = data(dadosRecebidos.datacertificado);
                dadosRecebidos.nomeIdioma = dadosRecebidos.idioma?.nome;
                dadosRecebidos.idioma = dadosRecebidos.idioma?.codigo;

                baseUpdatedAtRef.current = response.data.data.updated_at ?? null; // versão carregada (trava de concorrência)
                setDados(dadosRecebidos);

                //verifica se existe UF no enderecomunicipio e atribui ao enderecouf
                if (dadosRecebidos.enderecomunicipio?.uf) {
                    setDados(prevDados => ({
                        ...prevDados,
                        enderecouf: dadosRecebidos.enderecomunicipio.uf
                    }));
                }

                //atualiza lista de historico do participante
                buscarHistorico(id);

            }).catch(err => {
                //console.log(err)
            }).finally(() => {
                setIsLoading(false);
            });
        }//id id
        else {
            setDados({
                ...dados,
                ...{
                    evento: evento,
                    tipoCadastro: 'participante',
                }
            });
            // cadastro novo: sem participante carregado, o evento (e o cliente dele) vem daqui
            if (evento) {
                api({
                    method: "get",
                    action: '/evento',
                    token: token,
                    params: { id: evento }
                }).then(response => {
                    setEventoAtual(response.data.data[0] ?? null);
                }).catch(err => {
                    //console.log(err)
                });
            }
        }
    };
    const buscarHistorico = (idParticipante) => {
        // Loading proprio, e nao o do ErpTemplate: recarregar so o historico nao pode
        // cobrir a tela inteira e travar o formulario que o operador esta usando.
        setCarregandoHistorico(true);

        api({
            method: "get",
            action: '/participanteHistoricoSituacao',
            token: token,
            params: { participante: idParticipante }
        }).then(response => {
            var dadosRecebidosHistorico = response.data.data;
            setHistorico(dadosRecebidosHistorico);
        }).catch(err => {
            //console.log(err)
        }).finally(() => {
            setCarregandoHistorico(false);
        });
    };

    const salvar = () => {
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        let dadosSalvar = { ...dados }; //faz alterações antes de enviar para salvar
        if (dadosSalvar.hoteldatacheckin) {
            dadosSalvar.hoteldatacheckin = dataMysql(dadosSalvar.hoteldatacheckin);
        }
        if (dadosSalvar.hoteldatacheckout) {
            dadosSalvar.hoteldatacheckout = dataMysql(dadosSalvar.hoteldatacheckout);
        }
        if (dadosSalvar.datanascimento) {
            dadosSalvar.datanascimento = dataMysql(dadosSalvar.datanascimento);
        }
        if (dadosSalvar.dataopcaoaereo) {
            dadosSalvar.dataopcaoaereo = dataMysql(dadosSalvar.dataopcaoaereo);
        }
        if (dadosSalvar.datacartainformativa) {
            dadosSalvar.datacartainformativa = dataHoraMysql(dadosSalvar.datacartainformativa + ' ' + dadosSalvar.horacartainformativa);
        }
        if (dadosSalvar.dataconfirmacaocartainformativa) {
            dadosSalvar.dataconfirmacaocartainformativa = dataMysql(dadosSalvar.dataconfirmacaocartainformativa);
        }
        if (dadosSalvar.datacartaconvite) {
            dadosSalvar.datacartaconvite = dataHoraMysql(dadosSalvar.datacartaconvite + ' ' + dadosSalvar.horacartaconvite);
        }
        if (dadosSalvar.datacartaassinada) {
            dadosSalvar.datacartaassinada = dataHoraMysql(dadosSalvar.datacartaassinada + ' ' + dadosSalvar.horacartaassinada);
        }
        if (dadosSalvar.dataconfirmacaodados) {
            dadosSalvar.dataconfirmacaodados = dataMysql(dadosSalvar.dataconfirmacaodados);
        }
        if (dadosSalvar.dataescolhaaereo) {
            dadosSalvar.dataescolhaaereo = dataHoraMysql(dadosSalvar.dataescolhaaereo + ' ' + dadosSalvar.horaescolhaaereo);
        }
        if (dadosSalvar.datainscricao) {
            dadosSalvar.datainscricao = dataMysql(dadosSalvar.datainscricao);
        }
        if (dadosSalvar.datacertificado) {
            dadosSalvar.datacertificado = dataHoraMysql(dadosSalvar.datacertificado + ' ' + dadosSalvar.horacertificado);
        }

        const normalizarCampoRelacao = (campo) => {
            if (dadosSalvar[campo] && typeof dadosSalvar[campo] === 'object') {
                dadosSalvar[campo] = dadosSalvar[campo].id ?? dadosSalvar[campo].value ?? null;
            }
        };

        [
            'evento',
            'situacaoevento',
            'passaportearquivo',
            'enderecopais',
            'aereomunicipioembarque',
            'enderecomunicipio',
            'tipoparticipante',
            'hotelmunicipio',
            'banco',
        ].forEach(normalizarCampoRelacao);

        if (id) {
            delete dadosSalvar.evento;
        } else if (!dadosSalvar.evento && evento) {
            dadosSalvar.evento = evento;
        }

        if (arquivoPassaporte instanceof File) {
            dadosSalvar.passaporte = arquivoPassaporte;
        }

        if (dadosSalvar.anexos) {
            const anexo = {};
            dadosSalvar.anexos = dadosSalvar.anexos.map((item, i) => {
                const { arquivo, ...meta } = item;
                if (arquivo?._file instanceof File) {
                    anexo[i] = arquivo._file;
                }
                return { ...meta, arquivo: arquivo?.id ?? null };
            });
            if (Object.keys(anexo).length > 0) {
                dadosSalvar.anexo = anexo;
            }
        }

        // trava de concorrência: manda a versão carregada para o back barrar escrita desatualizada
        dadosSalvar.baseUpdatedAt = baseUpdatedAtRef.current;

        api({
            method: id ? 'put' : 'post',
            action: id ? '/participante/' + id : '/participante',
            token: token,
            data: dadosSalvar,
        })
            .then(function (response) {
                if (id) {
                    const subiuAnexo = arquivoPassaporte instanceof File || !!dadosSalvar.anexo;
                    if (arquivoPassaporte instanceof File) {
                        setArquivoPassaporte(null);
                        if (inputPassaporteRef.current) {
                            inputPassaporteRef.current.value = "";
                        }
                    }
                    if (subiuAnexo) {
                        // subiu arquivo: refetch completo para trazer os objetos persistidos
                        // (passaportearquivo/anexos), além de renovar a trava de concorrência e o histórico
                        buscar();
                    } else {
                        // sem anexo novo: evita o refetch completo — só renova a trava de concorrência
                        // com o updated_at recém-gravado (mesmo serialize do buscar) e atualiza o histórico
                        baseUpdatedAtRef.current = response.data.data?.updated_at ?? baseUpdatedAtRef.current;
                        buscarHistorico(id);
                    }
                    toast.success("As alterações foram salvas com sucesso!");
                } else {
                    history.push("/eventoParticipante/" + evento);
                }
            })
            .catch(function (error) {
                if (error.response?.status === 409 && error.response?.data?.error === 'STALE_WRITE') {
                    toast.error('Esta tela foi carregada antes de uma atualização mais recente. Atualize a página e tente novamente.');
                    return;
                }
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(function () {
                setIsSubmitting(false);
            });
    };


    // Carta que sai da fila deixa a tela desatualizada: o envio muda a situacao do
    // participante, carimba a data da carta e escreve a linha de historico — tudo no
    // back, sem esta aba saber. Aqui a marca do topo deixa de existir, e e nesse
    // instante que recarregamos. `buscar()` ja traz o historico junto.
    //
    // So na transicao tinha -> nao tem. Recarregar a cada resposta do polling
    // atropelaria o que o operador estivesse digitando, de dez em dez segundos.
    const tinhaCartaNaFila = useRef(0);

    // Qual participante a sentinela acima esta observando. Sem isto ela atravessa a troca de
    // participante — na tela do operador o botao Proximo substitui `dados` sem desmontar, e o
    // poll seguinte anunciava "a carta saiu da fila e foi enviada" para quem nunca teve carta.
    const participanteObservado = useRef(null);

    const [cartaSaiuDaFila, setCartaSaiuDaFila] = useState(false);
    const [carregandoHistorico, setCarregandoHistorico] = useState(false);

    useEffect(() => {
        const alvo = id ?? null;

        // Conta so o que esta VIVO. `porParticipante` traz tambem `falhou`, que e terminal e
        // fica ate um reenvio: olhar a presenca de qualquer entrada fazia o participante com
        // falha antiga nunca disparar o aviso, e a tela seguia com a situacao e a data de antes
        // ate o Salvar bater em STALE_WRITE. Compara quantidade, e nao existencia, para o
        // primeiro de dois envios vivos tambem ser anunciado.
        const vivasAgora = ((alvo && fila.porParticipante[alvo]) || [])
            .filter((e) => e.status === 'pendente' || e.status === 'processando').length;

        // Trocou de participante: re-semeia e nao avalia transicao nenhuma.
        if (participanteObservado.current !== alvo) {
            participanteObservado.current = alvo;
            tinhaCartaNaFila.current = vivasAgora;
            setCartaSaiuDaFila(false);

            return;
        }

        if (vivasAgora < tinhaCartaNaFila.current) {
            // Historico pode recarregar sozinho: e lista de leitura, nao ha nada do
            // operador ali para se perder.
            buscarHistorico(id);

            // Os dados do cadastro NAO. `buscar()` substitui o formulario inteiro, e o
            // operador pode estar com campos preenchidos e nao salvos — recarregar aqui
            // apagaria o que ele digitou. Em vez disso avisamos, e ele decide quando.
            setCartaSaiuDaFila(true);
        }

        tinhaCartaNaFila.current = vivasAgora;
        // Alinhado com a tela do operador. Aqui o id vem do match.params e nao muda sem
        // remontar, entao e consistencia, nao correcao.
        // eslint-disable-next-line
    }, [fila.porParticipante, id]);

    useEffect(() => { //onload
        const campoNome = document.querySelector("#nome");
        if (campoNome) {
            campoNome.focus(); //autofocus no nome
        }
        buscar();
    },
        // eslint-disable-next-line
        []);

    const idaSalva = getOpcaoIda(dados);
    const retornoSalva = getOpcaoRetorno(dados);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        {/* Flex em vez de `verticalAlign` nas marcas: o texto do titulo e as
                            marcas tem alturas de linha diferentes, e alinhar cada uma por
                            conta deixava a pilula da fila fora do eixo. O `gap` tambem some
                            sozinho quando a marca nao existe, o que o `marginLeft` nao fazia. */}
                        <h2 className="fin-pp__title" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            Cadastro de Participante
                            {dados.origemregistro === 'evento' ?
                                <span className="fin-pp__minitag is-warn" title="Cadastrado durante o evento pela lista digital">Incluso no local</span>
                                : null}
                            <BadgeCartaFila entradas={fila.porParticipante[id]} variante="cabecalho" />
                        </h2>
                        <p className="fin-pp__subtitle">{dados.evento?.nome ?? ''}</p>
                    </div>
                    <div className="fin-pp__actions">
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            color="secondary"
                            data={{
                                token: token,
                                tipoCarta: "modeloemailconvite",
                                idParticipantes: id,
                                formato: "html"
                            }}
                        >
                            <FaEye size={14} /> E-mail Convite
                        </FormButton>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            color="secondary"
                            data={{
                                token: token,
                                tipoCarta: "modelocartaconvite",
                                idParticipantes: id
                            }}
                        >
                            <FaEye size={14} /> Carta Convite
                        </FormButton>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--pill"
                            onClick={() => {
                                Alert({
                                    icon: "question",
                                    confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
                                    denyButton: <><FaThumbsDown size={20} /> Sair</>,
                                    title: tituloAlertaConvite,
                                    callBack: (result) => {
                                        if (result.isConfirmed) {
                                            enviarConviteRequest(false);
                                        }
                                    }
                                });
                            }}
                        >
                            <RiMailSendLine size={16} /> {textoBotaoConvite}
                        </button>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            color="secondary"
                            data={{
                                token: localStorage.getItem('token'),
                                tipoCarta: "modeloemailinformativa",
                                idParticipantes: id,
                                formato: "html"
                            }}
                        >
                            <FaEye size={14} /> E-mail Informativa
                        </FormButton>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            color="secondary"
                            data={{
                                token: localStorage.getItem('token'),
                                tipoCarta: "modelocarta",
                                idParticipantes: id
                            }}
                        >
                            <FaEye size={14} /> Carta Informativa
                        </FormButton>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--pill"
                            onClick={() => enviarInformativa()}
                        >
                            <RiMailSendLine size={16} /> Enviar Informativa
                        </button>
                        <a href={"/cadastroEventoRsvpOpcaoAereo/" + dados.evento?.id + "?idParticipante=" + id} className="fin-pp__btn fin-pp__btn--pill">
                            <FaPlane size={14} /> Opções de Aéreo
                        </a>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                            onClick={salvar}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </div>

                {/* Aviso em vez de recarregar sozinho: `buscar()` troca o formulario
                    inteiro e apagaria o que o operador tenha digitado e nao salvo. Quem
                    decide a hora e ele. O historico logo abaixo ja se atualizou sozinho,
                    porque ali nao ha nada dele para perder. */}
                {cartaSaiuDaFila ? (
                    <div className="fin-pp__banner is-warn">
                        <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                        <span>
                            A carta deste participante saiu da fila e foi enviada. A situação e a data
                            da carta mudaram no servidor, e esta tela ainda mostra os valores de antes.
                            {' '}
                            <button
                                type="button"
                                className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm"
                                style={{ marginLeft: 6 }}
                                onClick={() => { setCartaSaiuDaFila(false); buscar(); }}>
                                <FaSync size={13} /> Atualizar dados
                            </button>
                        </span>
                    </div>
                ) : null}


                {/* Pills de status das cartas */}
                {(dados.datacartaconvite || dados.datacartaassinada || dados.datacartainformativa || dados.dataconfirmacaocartainformativa || dados.datacertificado) && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                        {dados.datacartaconvite && (
                            <span className="fin-pp__pill is-info" title={"Carta convite enviada em: " + (dados.datacartaconvite ?? "") + ' ' + (dados.horacartaconvite ?? "")}>
                                Carta convite enviada em: {(dados.datacartaconvite ?? "") + ' ' + (dados.horacartaconvite ?? "")}
                            </span>
                        )}
                        {dados.datacartaassinada && (
                            <span className="fin-pp__pill is-ok" title={"Carta convite confirmada em: " + (dados.datacartaassinada ?? "") + ' ' + (dados.horacartaassinada ?? "")}>
                                Carta convite confirmada em: {(dados.datacartaassinada ?? "") + ' ' + (dados.horacartaassinada ?? "")}
                            </span>
                        )}
                        {dados.datacartainformativa && (
                            <span className="fin-pp__pill is-info" title={"Carta informativa enviada em: " + (dados.datacartainformativa ?? "") + ' ' + (dados.horacartainformativa ?? "")}>
                                Carta informativa enviada em: {(dados.datacartainformativa ?? "") + ' ' + (dados.horacartainformativa ?? "")}
                            </span>
                        )}
                        {dados.dataconfirmacaocartainformativa && (
                            <span className="fin-pp__pill is-ok" title={"Carta informativa confirmada em: " + (dados.dataconfirmacaocartainformativa ?? "")}>
                                Carta informativa confirmada em: {(dados.dataconfirmacaocartainformativa ?? "")}
                            </span>
                        )}
                        {dados.datacertificado && (
                            <span className="fin-pp__pill is-info" title={"Certificado enviado em: " + (dados.datacertificado ?? "") + ' ' + (dados.horacertificado ?? "")}>
                                Certificado enviado em: {(dados.datacertificado ?? "") + ' ' + (dados.horacertificado ?? "")}
                            </span>
                        )}
                    </div>
                )}

                {/* Tabs nativas */}
                <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'geral' ? 'active' : ''}`} onClick={() => setTab('geral')}>
                            Geral
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'anexos' ? 'active' : ''}`} onClick={() => setTab('anexos')}>
                            Anexos
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'colunasnomeaveis' ? 'active' : ''}`} onClick={() => setTab('colunasnomeaveis')}>
                            Colunas Nomeáveis
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'endereco' ? 'active' : ''}`} onClick={() => setTab('endereco')}>
                            Endereço
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'hotel' ? 'active' : ''}`} onClick={() => setTab('hotel')}>
                            <input type="checkbox" readOnly checked={dados.hotelhospedagem === 'sim'} style={{ marginRight: 4 }} /> Hospedagem
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'aereo' ? 'active' : ''}`} onClick={() => setTab('aereo')}>
                            <input type="checkbox" readOnly checked={dados.aereo === 'sim'} style={{ marginRight: 4 }} /> Aéreo
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'inscricao' ? 'active' : ''}`} onClick={() => setTab('inscricao')}>
                            <input type="checkbox" readOnly checked={dados.inscricao === 'sim'} style={{ marginRight: 4 }} /> Inscrição
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'transfer' ? 'active' : ''}`} onClick={() => setTab('transfer')}>
                            <input type="checkbox" readOnly checked={dados.transfer === 'sim' || dados.transferextra === 'sim'} style={{ marginRight: 4 }} /> Transfer
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="button" className={`nav-link ${tab === 'observacao' ? 'active' : ''}`} onClick={() => setTab('observacao')}>
                            Observações Importantes
                        </button>
                    </li>
                </ul>

                {/* ====== TAB GERAL ====== */}
                {tab === 'geral' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaUser size={15} /></span>
                            <span className="fin-pp__cphead-title">Dados de Identificação</span>
                        </div>
                        {!escolherTipoPrimeiro && (
                        <div className="fin-pp__filters">
                            <FinField label="Código">
                                <FinInput id="codigo" value={dados.codigo ?? ''} onChange={e => setDados({ ...dados, ...{ "codigo": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="CPF">
                                <InputMask mask="999.999.999-99" id="cpf" value={dados.cpf ?? ''} onChange={e => setDados({ ...dados, ...{ "cpf": e.target.value } })} disabled={dados.idioma === 'ingles'} className="fin-pp__input" style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="RG">
                                <FinInput id="rg" value={dados.rg ?? ''} onChange={e => setDados({ ...dados, ...{ "rg": e.target.value } })} disabled={dados.idioma === 'ingles'} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Identificação Laboratório">
                                <FinInput id="identificacao" value={dados.identificacao ?? ''} onChange={e => setDados({ ...dados, ...{ "identificacao": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        )}
                        <div className="fin-pp__filters">
                            <FinField label="Nome" required>
                                <FinInput id="nome" value={dados.nome ?? ''} onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Tipo do Participante">
                                <ReactSelect
                                    id="tipoparticipante"
                                    // o AsyncSelect cacheia as opções da montagem, quando a categoria do
                                    // evento ainda não resolveu; a key remonta o select quando ela chega
                                    key={categoriaTipos ?? 'todos'}
                                    value={dados.tipoparticipante ? { value: dados.tipoparticipante, label: dados.nomeTipoparticipante } : null}
                                    onChange={e => setDados({ ...dados, ...{ "tipoparticipante": e ? e.value : '', "nomeTipoparticipante": e ? e.label : '' }, ...(e && String(e.value) === '4' ? { "tipoinscricao": "online" } : {}) })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participanteTipo',
                                            token: token,
                                            // a categoria do evento define quais tipos existem para ele (o "Ambos", todos)
                                            params: { nome: input, categoria: categoriaTipos }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            {!escolherTipoPrimeiro && (
                            <FinField label="Nome para o Crachá">
                                <FinInput id="contato" value={dados.contato ?? ''} onChange={e => setDados({ ...dados, ...{ "contato": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            )}
                        </div>
                        {!escolherTipoPrimeiro && (<>
                        <div className="fin-pp__filters">
                            <FinField label="Telefone">
                                <FinInput id="telefone" value={dados.telefone ?? ''} onChange={e => setDados({ ...dados, ...{ "telefone": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Telefone 2">
                                <FinInput id="telefone2" value={dados.telefone2 ?? ''} onChange={e => setDados({ ...dados, ...{ "telefone2": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Celular">
                                <InputMask mask="(99) 99999-9999" id="celular" value={dados.celular ?? ''} onChange={e => setDados({ ...dados, ...{ "celular": e.target.value } })} className="fin-pp__input" style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="E-mail">
                                <FinInput id="email" type="email" value={dados.email ?? ''} onChange={e => setDados({ ...dados, ...{ "email": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Outros E-mails" full>
                                <FinInput id="emailsecundario" value={dados.emailsecundario ?? ''} onChange={e => setDados({ ...dados, ...{ "emailsecundario": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        {naoFarmaceutico ? (
                            <div className="fin-pp__filters">
                                <FinField label="Cargo">
                                    <ReactSelect
                                        id="cargoparticipante"
                                        value={dados.cargoparticipante ? { value: dados.cargoparticipante, label: dados.nomeCargoparticipante } : null}
                                        onChange={e => setDados({
                                            ...dados,
                                            ...{ "cargoparticipante": e ? e.value : '', "nomeCargoparticipante": e ? e.label : '' },
                                            // trocar de "Outros" para outro cargo limpa a especificação, que deixa de fazer sentido
                                            ...(e && String(e.value) === CARGO_OUTROS ? {} : { "cargoespecificacao": '' })
                                        })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/participanteCargo',
                                                token: token,
                                                params: { nome: input, categoria: CATEGORIA_NAO_FARMACEUTICO }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                                {cargoEhOutros ? (
                                    <FinField label="Especificação do Cargo">
                                        <FinInput id="cargoespecificacao" value={dados.cargoespecificacao ?? ''} onChange={e => setDados({ ...dados, ...{ "cargoespecificacao": e.target.value } })} style={{ paddingLeft: 14 }} />
                                    </FinField>
                                ) : null}
                            </div>
                        ) : (
                        <div className="fin-pp__filters">
                            <FinField label="Especialidade">
                                <FinInput id="especialidade" value={dados.especialidade ?? ''} onChange={e => setDados({ ...dados, ...{ "especialidade": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="CRM">
                                <div style={{ position: 'relative' }}>
                                    <FinInput
                                        id="crm"
                                        value={(verCrmOriginal ? dados.crmOriginal : dados.crm) ?? ''}
                                        onChange={e => {
                                            const r = formatCrm(e.target.value, dados?.crm, dados?.crmuf);
                                            setDados({ ...dados, ...{ "crm": r.crm, "crmuf": r.crmuf, "nomeUf": r.crmuf } });
                                        }}
                                        disabled={verCrmOriginal || dados.idioma === 'ingles' || !isTipoHcp(dados.tipoparticipante)}
                                        style={{ paddingLeft: 14, paddingRight: dados.crmOriginal && dados.crm !== dados.crmOriginal ? 116 : 14 }}
                                    />
                                    {dados.crmOriginal && dados.crm !== dados.crmOriginal && (
                                        <span
                                            className="fin-pp__minitag is-warn"
                                            style={{ position: 'absolute', top: '50%', right: 10, transform: 'translateY(-50%)', cursor: 'pointer' }}
                                            title={verCrmOriginal ? 'Mostrando o CRM original da importação' : 'O convidado alterou o CRM; clique para ver o original'}
                                            onClick={() => setVerCrmOriginal((prev) => !prev)}
                                        >
                                            {verCrmOriginal ? 'Original' : 'Alterado'} {verCrmOriginal ? <FaEye size={11} /> : <FaEyeSlash size={11} />}
                                        </span>
                                    )}
                                </div>
                            </FinField>
                            <FinField label="Estado do CRM">
                                <ReactSelect
                                    id="crmuf"
                                    value={dados.crmuf ? { value: dados.crmuf, label: dados.crmuf } : null}
                                    isDisabled={verCrmOriginal || dados.idioma === 'ingles' || !isTipoHcp(dados.tipoparticipante)}
                                    onChange={e => {
                                        const crmuf = e ? e.value : '';
                                        const nomeUf = e ? e.label : '';
                                        const r = formatCrm((crmuf || '') + (dados?.crm ?? '').replace(/\D/g, ''), dados?.crm, crmuf);
                                        setDados({ ...dados, ...{ "crmuf": crmuf, "nomeUf": nomeUf, "crm": r.crm } });
                                    }}
                                    options={OPCOES_UF}
                                />
                            </FinField>
                            <div className="fin-pp__field">
                                {/* Não se aplica junto do label externo, no mesmo field para nunca se separar do campo */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                    <label className="fin-pp__label" htmlFor="conselho">Dados do Conselho</label>
                                    <FinCheck
                                        id="conselhoNaoAplicavel"
                                        label="Não se aplica"
                                        checked={!!dados.conselhoNaoAplicavel}
                                        disabled={dados.idioma === 'ingles' || isTipoHcp(dados.tipoparticipante)}
                                        onChange={e => setDados({ ...dados, ...{ "conselhoNaoAplicavel": e.target.checked, ...(e.target.checked ? { "conselho": '', "conselhouf": '' } : {}) } })}
                                    />
                                </div>
                                <FinInput
                                    id="conselho"
                                    value={dados.conselho ?? ''}
                                    onChange={e => setDados({ ...dados, ...{ "conselho": e.target.value } })}
                                    disabled={dados.idioma === 'ingles' || isTipoHcp(dados.tipoparticipante) || !!dados.conselhoNaoAplicavel}
                                    style={{ paddingLeft: 14 }}
                                />
                            </div>
                            <FinField label="Estado do Conselho" htmlFor="conselhouf">
                                <ReactSelect
                                    id="conselhouf"
                                    value={dados.conselhouf ? { value: dados.conselhouf, label: dados.conselhouf } : null}
                                    isDisabled={dados.idioma === 'ingles' || isTipoHcp(dados.tipoparticipante) || !!dados.conselhoNaoAplicavel}
                                    onChange={e => setDados({ ...dados, ...{ "conselhouf": e ? e.value : '' } })}
                                    options={OPCOES_UF}
                                />
                            </FinField>
                        </div>
                        )}
                        <div className="fin-pp__filters">
                            <FinField label="Instituição">
                                <FinInput id="instituicao" value={dados.instituicao ?? ''} onChange={e => setDados({ ...dados, ...{ "instituicao": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Passaporte">
                                <FinInput id="passaporte" value={dados.passaporte ?? ''} onChange={e => setDados({ ...dados, ...{ "passaporte": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Vencimento do Passaporte">
                                <FinInput id="passaportevencimento" value={dados.passaportevencimento ?? ''} onChange={e => setDados({ ...dados, ...{ "passaportevencimento": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <Data
                                id="datanascimento"
                                label="Data de Nascimento"
                                value={dados.datanascimento}
                                onChange={date => setDados({ ...dados, ...{ "datanascimento": date } })}
                            />
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Produto / Linha">
                                <FinInput id="produto" value={dados.produto ?? ''} onChange={e => setDados({ ...dados, ...{ "produto": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Centro de Custo">
                                <FinInput id="centrodecusto" value={dados.centrodecusto ?? ''} onChange={e => setDados({ ...dados, ...{ "centrodecusto": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Ordem Interna">
                                <FinInput id="ordeminterna" value={dados.ordeminterna ?? ''} onChange={e => setDados({ ...dados, ...{ "ordeminterna": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Gerente Comercial">
                                <FinInput id="gerentecomercial" value={dados.gerentecomercial ?? ''} onChange={e => setDados({ ...dados, ...{ "gerentecomercial": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Gerente Distrital">
                                <FinInput id="gerentedistrital" value={dados.gerentedistrital ?? ''} onChange={e => setDados({ ...dados, ...{ "gerentedistrital": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="E-mail Gerente Distrital">
                                <FinInput id="gerentedistritalemail" value={dados.gerentedistritalemail ?? ''} onChange={e => setDados({ ...dados, ...{ "gerentedistritalemail": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Representante">
                                <FinInput id="representante" value={dados.representante ?? ''} onChange={e => setDados({ ...dados, ...{ "representante": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="E-mail Representante">
                                <FinInput id="representanteemail" value={dados.representanteemail ?? ''} onChange={e => setDados({ ...dados, ...{ "representanteemail": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Regional / Região">
                                <FinInput id="regional" value={dados.regional ?? ''} onChange={e => setDados({ ...dados, ...{ "regional": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Presente no Evento">
                                {/* rótulo sai da própria lista: `nomePresentenoevento` só era preenchido no onChange,
                                    então participante já salvo abria com o campo em branco */}
                                <ReactSelect
                                    value={OPCOES_PRESENTE.find((opcao) => opcao.value === (dados.presentenoevento || 'nulo')) ?? OPCOES_PRESENTE[0]}
                                    onChange={e => setDados({ ...dados, ...{ "presentenoevento": e ? e.value : 'nulo' } })}
                                    options={OPCOES_PRESENTE}
                                />
                            </FinField>
                            <FinField label="Sócio">
                                <FinInput id="socio" value={dados.socio ?? ''} onChange={e => setDados({ ...dados, ...{ "socio": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Idioma">
                                <ReactSelect
                                    value={dados.idioma ? { value: dados.idioma, label: dados.nomeIdioma } : null}
                                    onChange={e => setDados({ ...dados, ...{ "idioma": e ? e.value : '', "nomeIdioma": e ? e.label : '' } })}
                                    defaultOptions
                                    loadOptions={() => api({ method: 'get', action: '/idioma', token })
                                        .then(r => r.data.data.map(i => ({ value: i.codigo, label: i.nome })))
                                    }
                                />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Restrição Alimentar">
                                <FinInput id="restricaoalimentar" value={dados.restricaoalimentar ?? ''} onChange={e => setDados({ ...dados, ...{ "restricaoalimentar": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="PCD">
                                <FinInput id="pcd" value={dados.pcd ?? ''} onChange={e => setDados({ ...dados, ...{ "pcd": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="ID">
                                <FinInput id="idconvidado" value={dados.idconvidado ?? ''} onChange={(e) => {
                                    dados.idconvidado = e.target.value;
                                    setDados({ ...dados });
                                }} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>

                        {/* Datas de controle */}
                        <div className="fin-pp__cphead" style={{ marginTop: 16 }}>
                            <span className="fin-pp__cphead-ic"><FaHistory size={15} /></span>
                            <span className="fin-pp__cphead-title">Controle de Envios</span>
                        </div>
                        <div className="fin-pp__filters">
                            <Data
                                readOnly={true}
                                id="datacartaconvite"
                                label="Data Carta Convite"
                                value={dados.datacartaconvite}
                                onChange={date => setDados({ ...dados, ...{ "datacartaconvite": date } })}
                            />
                            <FinField label="Hora Carta Convite">
                                <InputMask mask="99:99" readOnly id="horacartaconvite" value={dados.horacartaconvite ?? ''} onChange={e => setDados({ ...dados, ...{ "horacartaconvite": e.target.value } })} className="fin-pp__input campoHora" style={{ paddingLeft: 14 }} />
                            </FinField>
                            <Data
                                readOnly={true}
                                id="datacartaassinada"
                                label="Data Aceite Convite"
                                value={dados.datacartaassinada}
                                onChange={date => setDados({ ...dados, ...{ "datacartaassinada": date } })}
                            />
                            <FinField label="Hora Aceite Convite">
                                <InputMask mask="99:99" readOnly id="horacartaassinada" value={dados.horacartaassinada ?? ''} onChange={e => setDados({ ...dados, ...{ "horacartaassinada": e.target.value } })} className="fin-pp__input campoHora" style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <Data
                                readOnly={true}
                                id="dataopcaoaereo"
                                label="Data Opção de Aéreo"
                                value={dados.dataopcaoaereo}
                                onChange={date => setDados({ ...dados, ...{ "dataopcaoaereo": date } })}
                            />
                            <Data
                                readOnly={true}
                                id="dataconfirmacaodados"
                                label="Data Confirmação Dados"
                                value={dados.dataconfirmacaodados}
                                onChange={date => setDados({ ...dados, ...{ "dataconfirmacaodados": date } })}
                            />
                            <Data
                                readOnly={true}
                                id="dataescolhaaereo"
                                label="Data Escolha Aéreo"
                                value={dados.dataescolhaaereo}
                                onChange={date => setDados({ ...dados, ...{ "dataescolhaaereo": date } })}
                            />
                            <FinField label="Hora Escolha Aéreo">
                                <InputMask mask="99:99" readOnly id="horaescolhaaereo" value={dados.horaescolhaaereo ?? ''} onChange={e => setDados({ ...dados, ...{ "horaescolhaaereo": e.target.value } })} className="fin-pp__input campoHora" style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <Data
                                id="datainscricao"
                                label="Data Inscrição"
                                value={dados.datainscricao}
                                onChange={date => setDados({ ...dados, ...{ "datainscricao": date } })}
                            />
                            <Data
                                id="datacartainformativa"
                                label="Data Carta Informativa"
                                value={dados.datacartainformativa}
                                onChange={date => setDados({ ...dados, ...{ "datacartainformativa": date } })}
                            />
                            <FinField label="Hora Carta Informativa">
                                <InputMask mask="99:99" id="horacartainformativa" value={dados.horacartainformativa ?? ''} onChange={e => setDados({ ...dados, ...{ "horacartainformativa": e.target.value } })} className="fin-pp__input campoHora" style={{ paddingLeft: 14 }} />
                            </FinField>
                            <Data
                                id="dataconfirmacaocartainformativa"
                                label="Data Confirmação Informativa"
                                value={dados.dataconfirmacaocartainformativa}
                                onChange={date => setDados({ ...dados, ...{ "dataconfirmacaocartainformativa": date } })}
                            />
                        </div>
                        <div className="fin-pp__filters">
                            <Data
                                id="datacertificado"
                                label="Data Certificado"
                                value={dados.datacertificado}
                                onChange={date => setDados({ ...dados, ...{ "datacertificado": date } })}
                            />
                            <FinField label="Hora Certificado">
                                <InputMask mask="99:99" id="horacertificado" value={dados.horacertificado ?? ''} onChange={e => setDados({ ...dados, ...{ "horacertificado": e.target.value } })} className="fin-pp__input campoHora" style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        </>)}
                    </div>
                )}

                {/* ====== TAB ANEXOS ====== */}
                {tab === 'anexos' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaFileAlt size={15} /></span>
                            <span className="fin-pp__cphead-title">Anexos Gerais</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
                            <div>
                                <label style={{ display: 'block', fontSize: 12, color: 'var(--fin-mt)', marginBottom: 4 }}>
                                    Anexos <small>(Selecione múltiplos arquivos)</small>
                                </label>
                                <input
                                    type="file"
                                    multiple
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14, width: 'auto', height: 'auto', padding: '6px 14px' }}
                                    onChange={(e) => {
                                        setDados(
                                            prev => ({
                                                ...prev,
                                                anexos: [
                                                    ...prev.anexos ?? [],
                                                    ...Array.from(e.target.files).map(file => ({ ...anexo, arquivo: { nome: file.name, _file: file } }))
                                                ]
                                            })
                                        );
                                        e.target.value = "";
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                                <FinChecks inline>
                                    <FinCheck id="anexo_convite" label="Convite" checked={anexo.convite} onChange={v => setAnexo(prev => ({ ...prev, convite: v.target.checked }))} />
                                    <FinCheck id="anexo_informativa" label="Informativa" checked={anexo.informativa} onChange={v => setAnexo(prev => ({ ...prev, informativa: v.target.checked }))} />
                                </FinChecks>
                            </div>
                        </div>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl">
                                <thead>
                                    <tr>
                                        <th style={{ width: 80 }}>Visualizar</th>
                                        <th style={{ width: 220 }}>Nome/Link</th>
                                        <th style={{ width: 200 }}>Upload</th>
                                        <th style={{ width: 280 }}>Operador</th>
                                        <th style={{ width: 90 }}>Convite</th>
                                        <th style={{ width: 100 }}>Informativa</th>
                                        <th style={{ width: 70 }}>Apagar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(dados.anexos ?? []).length === 0
                                        ? <tr><td colSpan={7} className="fin-pp__empty">Nenhum anexo</td></tr>
                                        : dados.anexos.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="fin-pp__btn fin-pp__btn--sm"
                                                        disabled={!item.id && !(item.arquivo?._file instanceof File)}
                                                        title="Visualizar"
                                                        onClick={() => {
                                                            if (item.arquivo?._file instanceof File) {
                                                                setPreviewAnexo({ localFile: item.arquivo._file, nome: item.arquivo.nome });
                                                            } else if (item.id) {
                                                                setPreviewAnexo({ arquivoId: item.arquivo?.id || item.arquivo, nome: item.arquivo?.nome ?? '' });
                                                            }
                                                        }}
                                                    >
                                                        <FaEye size={14} />
                                                    </button>
                                                </td>
                                                <td style={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <a
                                                        href={item.id && `${process.env.REACT_APP_API_URL}/arquivo/download/${item.arquivo?.id || item.arquivo}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: item.id ? 'var(--fin-ac)' : 'var(--fin-mt)', textDecoration: 'none' }}
                                                        title={(item.arquivo?.nome ?? '').split('\\').pop().split('/').pop()}
                                                    >
                                                        {(item.arquivo?.nome ?? '').split('\\').pop().split('/').pop()}
                                                    </a>
                                                </td>
                                                <td className="fin-pp__cell-muted">{item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm") : moment().format("DD/MM/YYYY HH:mm")}</td>
                                                <td className="fin-pp__cell-muted">{item.operador?.nome ?? getInternalAuth().nomeUsuario}</td>
                                                <td>
                                                    <FinChecks>
                                                        <FinCheck
                                                            id={"convite_" + index}
                                                            label=""
                                                            checked={item.convite}
                                                            onChange={v => setDados(prev => ({ ...prev, anexos: prev.anexos.map((i, e) => (e === index ? { ...i, convite: v.target.checked } : i)) }))}
                                                        />
                                                    </FinChecks>
                                                </td>
                                                <td>
                                                    <FinChecks>
                                                        <FinCheck
                                                            id={"informativa_" + index}
                                                            label=""
                                                            checked={item.informativa}
                                                            onChange={v => setDados(prev => ({ ...prev, anexos: prev.anexos.map((i, e) => (e === index ? { ...i, informativa: v.target.checked } : i)) }))}
                                                        />
                                                    </FinChecks>
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger"
                                                        onClick={() => setDados(prev => ({ ...prev, anexos: prev.anexos.filter((_, i) => i !== index) }))}
                                                        title="Excluir arquivo"
                                                    >
                                                        <FaTrash size={14} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        <VisualizarArquivoModal
                            show={!!previewAnexo}
                            onHide={() => setPreviewAnexo(null)}
                            arquivoId={previewAnexo?.arquivoId}
                            nome={previewAnexo?.nome}
                            localFile={previewAnexo?.localFile}
                        />
                    </div>
                )}

                {/* ====== TAB COLUNAS NOMEÁVEIS ====== */}
                {tab === 'colunasnomeaveis' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaColumns size={15} /></span>
                            <span className="fin-pp__cphead-title">Colunas Nomeáveis</span>
                        </div>
                        <div className="fin-pp__filters">
                            {/* Colunas vêm normalizadas do back (`colunas`): uma por coluna do evento,
                                com nome, ordem (que é a posição) e ativo. Não há mais 1..10 fixo — a 11ª
                                em diante aparece aqui sozinha. Travada no cadeado fica somente leitura. */}
                            {(dados.colunas ?? []).map(coluna => (
                                <FinField key={coluna.id} label={coluna.nome}>
                                    <FinInput
                                        id={'coluna' + coluna.ordem}
                                        value={coluna.valor ?? ''}
                                        disabled={!coluna.ativo}
                                        onChange={e => {
                                            const valor = e.target.value;
                                            setDados({
                                                ...dados,
                                                colunas: dados.colunas.map(atual => (
                                                    atual.id === coluna.id ? { ...atual, valor } : atual
                                                )),
                                            });
                                        }}
                                        style={{ paddingLeft: 14 }}
                                    />
                                </FinField>
                            ))}
                            {(dados.colunas ?? []).length === 0 && (
                                <span className="fin-pp__cell-muted">Este evento não tem colunas nomeáveis.</span>
                            )}
                        </div>
                    </div>
                )}

                {/* ====== TAB ENDEREÇO ====== */}
                {tab === 'endereco' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaMapMarkerAlt size={15} /></span>
                            <span className="fin-pp__cphead-title">Endereço</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Rua / Logradouro" full>
                                <FinInput id="enderecologradouro" value={dados.enderecologradouro ?? ''} onChange={e => setDados({ ...dados, ...{ "enderecologradouro": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Número">
                                <FinInput id="endereconumero" value={dados.endereconumero ?? ''} onChange={e => setDados({ ...dados, ...{ "endereconumero": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Complemento" full>
                                <FinInput id="enderecocomplemento" value={dados.enderecocomplemento ?? ''} onChange={e => setDados({ ...dados, ...{ "enderecocomplemento": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="CEP">
                                <FinInput id="enderecocep" value={dados.enderecocep ?? ''} onChange={(e) => {
                                    dados.enderecocep = e.target.value;
                                    preencherCep(e.target.value, dados);
                                    setDados({ ...dados });
                                }} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Bairro">
                                <FinInput id="enderecobairro" value={dados.enderecobairro ?? ''} onChange={e => setDados({ ...dados, ...{ "enderecobairro": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Estado">
                                <ReactSelect
                                    id="enderecouf"
                                    value={dados.enderecouf ? { value: dados.enderecouf, label: dados.enderecouf } : null}
                                    isDisabled={dados.idioma === 'ingles'}
                                    onChange={e => setDados({ ...dados, ...{ "enderecouf": e ? e.value : '', "nomeUf": e ? e.label : '' } })}
                                    options={OPCOES_UF}
                                />
                            </FinField>
                            <FinField label="Cidade">
                                <ReactSelect
                                    value={dados.enderecomunicipio ? { value: dados.enderecomunicipio, label: dados.nomeEnderecomunicipio } : null}
                                    isDisabled={dados.idioma === 'ingles'}
                                    onChange={e => setDados({ ...dados, ...{ "enderecomunicipio": e ? e.value : '', "nomeEnderecomunicipio": e ? e.label : '' } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/municipio',
                                            token: token,
                                            params: {
                                                nome: input,
                                                uf: dados.enderecouf ?? null
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="País">
                                <ReactSelect
                                    value={dados.enderecopais ? { value: dados.enderecopais, label: dados.nomeEnderecopais } : null}
                                    onChange={e => setDados({ ...dados, ...{ "enderecopais": e ? e.value : '', "nomeEnderecopais": e ? e.label : '' } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/pais',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                        </div>
                    </div>
                )}

                {/* ====== TAB HOSPEDAGEM ====== */}
                {tab === 'hotel' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaBed size={15} /></span>
                            <span className="fin-pp__cphead-title">Hospedagem</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Possui Hospedagem?">
                                <ReactSelect
                                    value={dados.hotelhospedagem ? { value: dados.hotelhospedagem, label: dados.nomeHotelhospedagem } : null}
                                    onChange={e => setDados({ ...dados, ...{ "hotelhospedagem": e ? e.value : '', "nomeHotelhospedagem": e ? e.label : '' } })}
                                    options={OPCOES_SIM_NAO_CLD}
                                />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Hotel" full>
                                <FinInput id="hotelnome" value={dados.hotelnome ?? ''} onChange={e => setDados({ ...dados, ...{ "hotelnome": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Tipo de Quarto">
                                <FinInput id="hoteltipoquarto" value={dados.hoteltipoquarto ?? ''} onChange={e => setDados({ ...dados, ...{ "hoteltipoquarto": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Rua/Logradouro" full>
                                <FinInput id="hotellogradouro" value={dados.hotellogradouro ?? ''} onChange={e => setDados({ ...dados, ...{ "hotellogradouro": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Bairro">
                                <FinInput id="hotelbairro" value={dados.hotelbairro ?? ''} onChange={e => setDados({ ...dados, ...{ "hotelbairro": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Cidade">
                                <ReactSelect
                                    value={dados.hotelmunicipio ? { value: dados.hotelmunicipio, label: dados.nomeHotelmunicipio } : null}
                                    onChange={e => setDados({ ...dados, ...{ "hotelmunicipio": e ? e.value : '', "nomeHotelmunicipio": e ? e.label : '' } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/municipio',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="Telefone">
                                <FinInput id="hoteltelefone" value={dados.hoteltelefone ?? ''} onChange={e => setDados({ ...dados, ...{ "hoteltelefone": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <Data
                                id="hoteldatacheckin"
                                label="Data do checkin"
                                value={dados.hoteldatacheckin}
                                onChange={date => setDados({ ...dados, ...{ "hoteldatacheckin": date } })}
                            />
                            <FinField label="Hora do checkin">
                                <InputMask mask="99:99" id="hotelhoracheckin" value={dados.hotelhoracheckin ?? ''} onChange={e => setDados({ ...dados, ...{ "hotelhoracheckin": e.target.value } })} className="fin-pp__input" style={{ paddingLeft: 14 }} />
                            </FinField>
                            <Data
                                id="hoteldatacheckout"
                                label="Data do checkout"
                                value={dados.hoteldatacheckout}
                                onChange={date => setDados({ ...dados, ...{ "hoteldatacheckout": date } })}
                            />
                            <FinField label="Hora do checkout">
                                <InputMask mask="99:99" id="hotelhoracheckout" value={dados.hotelhoracheckout ?? ''} onChange={e => setDados({ ...dados, ...{ "hotelhoracheckout": e.target.value } })} className="fin-pp__input" style={{ paddingLeft: 14 }} />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Observação" full>
                                <FinTextarea id="hotelobservacao" value={dados.hotelobservacao ?? ''} onChange={e => setDados({ ...dados, ...{ "hotelobservacao": e.target.value } })} />
                            </FinField>
                        </div>
                    </div>
                )}

                {/* ====== TAB AÉREO ====== */}
                {tab === 'aereo' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaPlaneIcon size={15} /></span>
                            <span className="fin-pp__cphead-title">Aéreo</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Possui Aéreo?">
                                <ReactSelect
                                    value={dados.aereo ? { value: dados.aereo, label: dados.nomeAereo } : null}
                                    onChange={e => setDados({ ...dados, ...{ "aereo": e ? e.value : '', "nomeAereo": e ? e.label : '' } })}
                                    options={OPCOES_SIM_NAO_CLD}
                                />
                            </FinField>
                            <FinField label="Bagagem Despachada?">
                                <ReactSelect
                                    value={dados.bagagemDespachada ? { value: dados.bagagemDespachada, label: dados.nomeBagagemDespachada } : null}
                                    onChange={e => setDados({ ...dados, ...{ "bagagemDespachada": e ? e.value : '', "nomeBagagemDespachada": e ? e.label : '' } })}
                                    options={OPCOES_SIM_NAO}
                                />
                            </FinField>
                        </div>

                        {dados.aereo === 'sim' && <>
                            {/* Dados Ida */}
                            <div className="fin-pp__cphead" style={{ marginTop: 12 }}>
                                <span className="fin-pp__cphead-ic"><FaPlaneDeparture size={15} /></span>
                                <span className="fin-pp__cphead-title">
                                    Dados Ida
                                    {idaCompleta(getOpcaoIda(dados)) && <span className="fin-pp__pill is-ok" style={{ marginLeft: 8 }}>Já Selecionado Pelo Participante</span>}
                                    {/* sem a pílula os campos ficam vazios e parece que a escolha não foi registrada */}
                                    {!!dados.naoutilizaraereoida && <span className="fin-pp__pill is-warn" style={{ marginLeft: 8 }}>Participante não utilizará este trecho</span>}
                                </span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Data">
                                    <FinInput id="aereoidadata" value={dados.aereoidadata ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidadata": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Origem">
                                    <FinInput id="aereoidaorigem" value={dados.aereoidaorigem ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidaorigem": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Companhia Aérea">
                                    <FinInput id="aereoidacompanhia" value={dados.aereoidacompanhia ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidacompanhia": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Voo">
                                    <FinInput id="aereoidavoo" value={dados.aereoidavoo ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidavoo": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Hora Saída">
                                    <FinInput id="aereoidahorasaida" value={dados.aereoidahorasaida ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidahorasaida": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Hora Chegada">
                                    <FinInput id="aereoidahorachegada" value={dados.aereoidahorachegada ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidahorachegada": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Destino">
                                    <FinInput id="aereoidadestino" value={dados.aereoidadestino ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidadestino": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Localizador">
                                    <FinInput id="aereoidalocalizador" value={dados.aereoidalocalizador ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidalocalizador": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="E-ticket">
                                    <FinInput id="aereoidaeticket" value={dados.aereoidaeticket ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidaeticket": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Conexão">
                                    <FinInput id="aereoidaconexao" value={dados.aereoidaconexao ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidaconexao": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Cidade Embarque">
                                    <ReactSelect
                                        value={dados.aereomunicipioembarque ? { value: dados.aereomunicipioembarque, label: dados.nomeAereomunicipioembarque } : null}
                                        onChange={e => setDados({ ...dados, ...{ "aereomunicipioembarque": e ? e.value : '', "nomeAereomunicipioembarque": e ? e.label : '' } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/municipio',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    uf: dados.enderecouf ?? null
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                                <FinField label="Aeroporto de Origem">
                                    <FinInput id="aeroportoOrigem" value={dados.aeroportoOrigem ?? ''} onChange={e => setDados({ ...dados, ...{ "aeroportoOrigem": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Trecho de ida">
                                    <label className="d-flex align-items-center" style={{ marginBottom: 0, minHeight: 46 }}>
                                        <input
                                            type="checkbox"
                                            id="naoutilizaraereoida"
                                            checked={!!dados.naoutilizaraereoida}
                                            onChange={e => setDados({ ...dados, ...{ "naoutilizaraereoida": e.target.checked } })}
                                            style={{ marginRight: 8 }}
                                        />
                                        Não utilizará este trecho
                                    </label>
                                </FinField>
                                <FinField label="Observação Ida" full>
                                    <FinTextarea id="aereoidaobservacao" value={dados.aereoidaobservacao ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoidaobservacao": e.target.value } })} />
                                </FinField>
                            </div>

                            {/* Dados Retorno */}
                            <div className="fin-pp__cphead" style={{ marginTop: 12 }}>
                                <span className="fin-pp__cphead-ic"><FaPlaneArrival size={15} /></span>
                                <span className="fin-pp__cphead-title">
                                    Dados Retorno
                                    {retornoCompleto(getOpcaoRetorno(dados)) && <span className="fin-pp__pill is-ok" style={{ marginLeft: 8 }}>Já Selecionado Pelo Participante</span>}
                                    {/* sem a pílula os campos ficam vazios e parece que a escolha não foi registrada */}
                                    {!!dados.naoutilizaraereoretorno && <span className="fin-pp__pill is-warn" style={{ marginLeft: 8 }}>Participante não utilizará este trecho</span>}
                                </span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Data">
                                    <FinInput id="aereoretornodata" value={dados.aereoretornodata ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornodata": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Origem">
                                    <FinInput id="aereoretornoorigem" value={dados.aereoretornoorigem ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornoorigem": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Companhia Aérea">
                                    <FinInput id="aereoretornocompanhia" value={dados.aereoretornocompanhia ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornocompanhia": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Voo">
                                    <FinInput id="aereoretornovoo" value={dados.aereoretornovoo ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornovoo": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Hora Saída">
                                    <FinInput id="aereoretornohorasaida" value={dados.aereoretornohorasaida ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornohorasaida": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Hora Chegada">
                                    <FinInput id="aereoretornohorachegada" value={dados.aereoretornohorachegada ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornohorachegada": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Destino">
                                    <FinInput id="aereoretornodestino" value={dados.aereoretornodestino ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornodestino": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Localizador">
                                    <FinInput id="aereoretornolocalizador" value={dados.aereoretornolocalizador ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornolocalizador": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="E-ticket">
                                    <FinInput id="aereoretornoeticket" value={dados.aereoretornoeticket ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornoeticket": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                                <FinField label="Conexão">
                                    <FinInput id="aereoretornoconexao" value={dados.aereoretornoconexao ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornoconexao": e.target.value } })} style={{ paddingLeft: 14 }} />
                                </FinField>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Trecho de retorno">
                                    <label className="d-flex align-items-center" style={{ marginBottom: 0, minHeight: 46 }}>
                                        <input
                                            type="checkbox"
                                            id="naoutilizaraereoretorno"
                                            checked={!!dados.naoutilizaraereoretorno}
                                            onChange={e => setDados({ ...dados, ...{ "naoutilizaraereoretorno": e.target.checked } })}
                                            style={{ marginRight: 8 }}
                                        />
                                        Não utilizará este trecho
                                    </label>
                                </FinField>
                                <FinField label="Observação Retorno" full>
                                    <FinTextarea id="aereoretornoobservacao" value={dados.aereoretornoobservacao ?? ''} onChange={e => setDados({ ...dados, ...{ "aereoretornoobservacao": e.target.value } })} />
                                </FinField>
                            </div>

                            <div className="fin-pp__filters">
                                <FinField label="Documentos necessários para entrada no país (se preenchido, sobrepõe o texto padrão do evento)" full>
                                    <FinTextarea id="documentosentradapais" value={dados.documentosentradapais ?? ''} onChange={e => setDados({ ...dados, ...{ "documentosentradapais": e.target.value } })} />
                                </FinField>
                            </div>

                            {/* Declaração escrita do convidado sobre o que ele tem/o que falta (tela de escolha
                                de aéreo). Editável aqui porque o RSVP complementa e corrige o que foi declarado
                                antes de repassar ao laboratório — é o mesmo campo que sai no relatório de
                                participantes e na planilha de emissão de aéreo. */}
                            <div className="fin-pp__filters">
                                <FinField label="Pendência de documentos para entrada no país (declarada pelo convidado)" full>
                                    <FinTextarea id="pendenciadocumentosentradapais" value={dados.pendenciadocumentosentradapais ?? ''} onChange={e => setDados({ ...dados, ...{ "pendenciadocumentosentradapais": e.target.value } })} />
                                </FinField>
                            </div>

                            {/* Carimbo do "Estou ciente..." marcado pelo convidado na tela de escolha de aéreo.
                                Só leitura: o setter é o escolhaAereo, e o Salvar desta tela não altera o campo. */}
                            {dados.datacientedocumentosentradapais &&
                                <div style={{ marginTop: 8 }}>
                                    <span className="fin-pp__pill is-ok" title={"O convidado declarou ciência dos documentos de entrada no país em: " + dataHora(dados.datacientedocumentosentradapais)}>
                                        Ciência dos documentos declarada em: {dataHora(dados.datacientedocumentosentradapais)}
                                    </span>
                                </div>
                            }

                            {/* Upload passaporte */}
                            <div style={{ marginTop: 16 }}>
                                <label style={{ display: 'block', fontSize: 12, color: 'var(--fin-mt)', marginBottom: 4 }}>Passaporte</label>
                                <input
                                    type="file"
                                    id="passaportearquivo"
                                    ref={inputPassaporteRef}
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    onChange={(e) => setArquivoPassaporte(e.target.files?.[0] ?? null)}
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14, width: 'auto', height: 'auto', padding: '6px 14px' }}
                                />
                                {dados?.passaportearquivo?.id && (
                                    <div style={{ marginTop: 6, color: 'var(--fin-mt)', fontSize: 13 }}>
                                        <strong>Arquivo atual:</strong>{' '}
                                        <a
                                            href={`${process.env.REACT_APP_API_URL}/arquivo/download/${dados.passaportearquivo.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: 'var(--fin-ac)', textDecoration: 'none' }}
                                        >
                                            {dados.passaportearquivo.nome?.split('\\').pop().split('/').pop() || 'Baixar passaporte enviado'}
                                        </a>
                                    </div>
                                )}
                            </div>

                            {/* Opções de aéreo disponíveis */}
                            <div style={{ marginTop: 20 }}>
                                <div className="fin-pp__cphead">
                                    <span className="fin-pp__cphead-ic"><FaPlaneDeparture size={15} /></span>
                                    <span className="fin-pp__cphead-title">Opções de Aéreo Disponíveis — Ida</span>
                                </div>
                                <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 12 }}>
                                    <div className="fin-pp__tblwrap">
                                        <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                            <thead>
                                                <tr>
                                                    <th>Data</th>
                                                    <th>Cia</th>
                                                    <th>Voo</th>
                                                    <th>Origem</th>
                                                    <th>Destino</th>
                                                    <th>Saída</th>
                                                    <th>Chegada</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dados.evento?.eventoaereo
                                                    ? dados.evento.eventoaereo.filter(idaTemDados).map((row, rowIndex) => (
                                                        <tr key={rowIndex} style={idaCompleta(idaSalva) && !compareIda(idaSalva, row) ? { opacity: 0.4 } : {}}>
                                                            <td>{(row.idadata ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{(row.idacompanhia ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{(row.idavoo ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td><LocalAereo valor={row.idaorigem} /></td>
                                                            <td><LocalAereo valor={row.idadestino} /></td>
                                                            <td>{(row.idahorasaida ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{(row.idahorachegada ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{compareIda(idaSalva, row) && <span className="fin-pp__pill is-ok">Selecionado</span>}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colSpan={8} className="fin-pp__empty">Nenhuma opção</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="fin-pp__cphead">
                                    <span className="fin-pp__cphead-ic"><FaPlaneArrival size={15} /></span>
                                    <span className="fin-pp__cphead-title">Opções de Aéreo Disponíveis — Volta</span>
                                </div>
                                <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 12 }}>
                                    <div className="fin-pp__tblwrap">
                                        <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                            <thead>
                                                <tr>
                                                    <th>Data</th>
                                                    <th>Cia</th>
                                                    <th>Voo</th>
                                                    <th>Origem</th>
                                                    <th>Destino</th>
                                                    <th>Saída</th>
                                                    <th>Chegada</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dados.evento?.eventoaereo
                                                    ? dados.evento.eventoaereo.filter(retornoTemDados).map((row, rowIndex) => (
                                                        <tr key={rowIndex} style={retornoCompleto(retornoSalva) && !compareRetorno(retornoSalva, row) ? { opacity: 0.4 } : {}}>
                                                            <td>{(row.retornodata ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{(row.retornocompanhia ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{(row.retornovoo ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td><LocalAereo valor={row.retornoorigem} /></td>
                                                            <td><LocalAereo valor={row.retornodestino} /></td>
                                                            <td>{(row.retornohorasaida ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{(row.retornohorachegada ?? '').split("|").map((valor, vi) => <span key={vi}>{valor}<br /></span>)}</td>
                                                            <td>{compareRetorno(retornoSalva, row) && <span className="fin-pp__pill is-ok">Selecionado</span>}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colSpan={8} className="fin-pp__empty">Nenhuma opção</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                )}

                {/* ====== TAB INSCRIÇÃO ====== */}
                {tab === 'inscricao' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaFileAlt size={15} /></span>
                            <span className="fin-pp__cphead-title">Inscrição</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Possui Inscrição?">
                                <ReactSelect
                                    value={dados.inscricao ? { value: dados.inscricao, label: dados.nomeInscricao } : null}
                                    onChange={e => setDados({ ...dados, ...{ "inscricao": e ? e.value : '', "nomeInscricao": e ? e.label : '' } })}
                                    options={OPCOES_SIM_NAO_CLD}
                                />
                            </FinField>
                            <FinField label="Número de Inscrição">
                                <FinInput id="inscricaonumero" value={dados.inscricaonumero ?? ''} onChange={e => setDados({ ...dados, ...{ "inscricaonumero": e.target.value } })} style={{ paddingLeft: 14 }} />
                            </FinField>
                            <FinField label="Tipo de Inscrição">
                                <div title={dados.evento?.tipoRealizacao === 'hibrido' ? undefined : 'Habilitado somente para eventos híbridos'}>
                                    <ReactSelect
                                        isDisabled={dados.evento?.tipoRealizacao !== 'hibrido'}
                                        value={dados.tipoinscricao ? { value: dados.tipoinscricao, label: dados.tipoinscricao === 'online' ? 'Online' : 'Presencial' } : null}
                                        onChange={e => setDados({ ...dados, ...{ "tipoinscricao": e ? e.value : '' } })}
                                        options={[
                                            { value: 'online', label: 'Online' },
                                            { value: 'presencial', label: 'Presencial' },
                                        ]}
                                    />
                                </div>
                            </FinField>
                        </div>
                    </div>
                )}

                {/* ====== TAB TRANSFER ====== */}
                {tab === 'transfer' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaBus size={15} /></span>
                            <span className="fin-pp__cphead-title">Transfer</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Possui Transfer?">
                                <ReactSelect
                                    value={dados.transfer ? { value: dados.transfer, label: dados.nomeTransfer } : null}
                                    onChange={e => setDados({ ...dados, ...{ "transfer": e ? e.value : '', "nomeTransfer": e ? e.label : '' } })}
                                    options={OPCOES_SIM_NAO_CLD}
                                />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Descrição do Transfer (se preenchido, sobrepõe o texto padrão do evento)" full>
                                <FinTextarea id="transferdescricao" value={dados.transferdescricao ?? ''} onChange={e => setDados({ ...dados, transferdescricao: e.target.value })} />
                            </FinField>
                            <FinField label="Observação Transfer" full>
                                <FinTextarea id="transferobservacao" value={dados.transferobservacao ?? ''} onChange={e => setDados({ ...dados, ...{ "transferobservacao": e.target.value } })} />
                            </FinField>
                        </div>
                        <hr style={{ margin: '16px 0', borderColor: 'var(--fin-acb)' }} />
                        <div className="fin-pp__filters">
                            <FinField label="Possui Transfer Extra?">
                                <ReactSelect
                                    value={dados.transferextra ? { value: dados.transferextra, label: dados.nomeTransferextra } : null}
                                    onChange={(e) => {
                                        dados.transferextra = e ? e.value : '';
                                        dados.nomeTransferextra = e ? e.label : '';
                                        setDados({ ...dados });
                                    }}
                                    options={OPCOES_SIM_NAO_CLD}
                                />
                            </FinField>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Descrição do Transfer Extra (se preenchido, sobrepõe o texto padrão do evento)" full>
                                <FinTextarea id="transferextradescricao" value={dados.transferextradescricao ?? ''} onChange={e => setDados({ ...dados, transferextradescricao: e.target.value })} />
                            </FinField>
                            <FinField label="Observação Transfer Extra" full>
                                <FinTextarea id="transferextraobservacao" value={dados.transferextraobservacao ?? ''} onChange={(e) => {
                                    dados.transferextraobservacao = e.target.value;
                                    setDados({ ...dados });
                                }} />
                            </FinField>
                        </div>
                    </div>
                )}

                {/* ====== TAB OBSERVAÇÕES ====== */}
                {tab === 'observacao' && (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaFileAlt size={15} /></span>
                            <span className="fin-pp__cphead-title">Observações Importantes</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Observações Importantes" full>
                                <FinTextarea id="observacao" value={dados.observacao ?? ''} onChange={(e) => {
                                    dados.observacao = e.target.value;
                                    setDados({ ...dados });
                                }} style={{ minHeight: 160 }} />
                            </FinField>
                        </div>
                    </div>
                )}

                {/* ====== SEÇÃO HISTÓRICO ====== */}
                <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                    <div className="fin-pp__cphead">
                        <span className="fin-pp__cphead-ic"><FaHistory size={15} /></span>
                        <span className="fin-pp__cphead-title">Dados de Histórico</span>
                    </div>

                    {/* Formulário de novo histórico */}
                    <form className="form" onSubmit={(e) => {
                        //valida se tem status
                        var modalsituacao = document.querySelector("#modalsituacao");
                        if (dadosModalHistorico.situacao === undefined || dadosModalHistorico.situacao === null || dadosModalHistorico.situacao === '') {
                            toast.error('É necessário preencher o status');
                            setTimeout(() => {
                                modalsituacao.focus();
                            }, 500);
                            e.preventDefault();
                            return false;
                        }

                        //valida se tem data e hora da situação
                        var campodatanotificacao = document.querySelector("#datanotificacao");
                        var campohoranotificacao = document.querySelector("#horanotificacao");
                        if (dadosModalHistorico.pedirdata === "sim") {
                            if (dadosModalHistorico.datanotificacao === undefined || dadosModalHistorico.datanotificacao === null || dadosModalHistorico.datanotificacao === '') {
                            } else {
                                if (dadosModalHistorico.horanotificacao === undefined || dadosModalHistorico.horanotificacao === null || dadosModalHistorico.horanotificacao === '') {
                                    toast.error('É necessário preencher a hora');
                                    setTimeout(() => {
                                        campohoranotificacao.focus();
                                    }, 500);
                                    e.preventDefault();
                                    return false;
                                }
                            }
                        }

                        var datanotificacao = null;
                        var horanotificacao = null;
                        if (dadosModalHistorico.datanotificacao !== undefined && dadosModalHistorico.datanotificacao !== null && dadosModalHistorico.datanotificacao !== '') {
                            datanotificacao = dataMysql(dadosModalHistorico.datanotificacao);
                            if (dadosModalHistorico.horanotificacao !== undefined && dadosModalHistorico.horanotificacao !== null && dadosModalHistorico.horanotificacao !== '') {
                                horanotificacao = dadosModalHistorico.horanotificacao;
                            }
                        }

                        api({
                            method: 'post',
                            action: '/participanteHistoricoSituacao',
                            token: token,
                            data: {
                                evento: dados.evento?.id,
                                participante: id,
                                situacao: dadosModalHistorico.situacao,
                                historico: dadosModalHistorico.historico,
                                datanotificacao: datanotificacao,
                                horanotificacao: horanotificacao,
                            }
                        })
                            .then(function (response) {
                                dadosModalHistorico.pedirdata = "nao";
                                dadosModalHistorico.datanotificacao = null;
                                dadosModalHistorico.horanotificacao = '';
                                dadosModalHistorico.historico = '';
                                dadosModalHistorico.situacao = null;
                                dadosModalHistorico.nomeSituacao = null;
                                setDadosModalHistorico({ ...dadosModalHistorico });
                                // a mudança de situação faz update no participante (situacaoevento) e avança o updated_at.
                                // recarrega o registro inteiro (buscar já refaz o histórico) pra re-sincronizar dados + a trava de
                                // concorrência — senão o próximo "Salvar" na mesma tela cai em STALE_WRITE (409) e ainda reverteria a situação.
                                buscar();
                                toast.success("Registrado com sucesso!");
                            })
                            .catch(function (error) {
                                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
                            });
                        e.preventDefault();
                    }}>
                        <div className="fin-pp__filters">
                            <FinField label="Status">
                                <ReactSelect
                                    id="modalsituacao"
                                    value={dadosModalHistorico.situacao ? { value: dadosModalHistorico.situacao, label: dadosModalHistorico.nomeSituacao, pedirdata: dadosModalHistorico.pedirdata } : null}
                                    onChange={(e) => {
                                        dadosModalHistorico.situacao = e ? e.value : null;
                                        dadosModalHistorico.nomeSituacao = e ? e.label : null;
                                        dadosModalHistorico.pedirdata = e ? e.pedirdata : null;
                                        setDadosModalHistorico({ ...dadosModalHistorico });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/eventoParticipanteSituacao',
                                            token: token,
                                            params: {
                                                situacaoRegistro: "ativo",
                                                nome: input,
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome, pedirdata: registro.pedirdata }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                        </div>
                        {dadosModalHistorico.pedirdata === "sim" && (
                            <div className="fin-pp__filters">
                                <Data
                                    title="Opcional"
                                    id="datanotificacao"
                                    label="Data"
                                    value={dadosModalHistorico.datanotificacao ?? ""}
                                    onChange={(date) => {
                                        dadosModalHistorico.datanotificacao = date;
                                        setDadosModalHistorico({ ...dadosModalHistorico });
                                    }}
                                />
                                <FinField label="Hora">
                                    <InputMask
                                        title="Opcional"
                                        mask="99:99"
                                        id="horanotificacao"
                                        value={dadosModalHistorico.horanotificacao ?? ""}
                                        onChange={(e) => {
                                            dadosModalHistorico.horanotificacao = e.target.value;
                                            setDadosModalHistorico({ ...dadosModalHistorico });
                                        }}
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                    />
                                </FinField>
                            </div>
                        )}
                        <div className="fin-pp__filters">
                            <FinField label="Observação">
                                <FinTextarea
                                    id="modalhistorico"
                                    value={dadosModalHistorico.historico ?? ''}
                                    onChange={(e) => {
                                        dadosModalHistorico.historico = e.target.value;
                                        setDadosModalHistorico({ ...dadosModalHistorico });
                                    }}
                                />
                            </FinField>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary">
                                Criar Observação
                            </button>
                        </div>
                    </form>

                    {/* Tabela de histórico */}
                    <TabelaHistoricoParticipante historico={historico} setHistorico={setHistorico} token={token} idParticipante={id} situacao={dados.situacaoevento} carregando={carregandoHistorico} />
                </div>
            </div>

            <ModalForcarEnvio
                show={forcarEnvio.show}
                mensagem={forcarEnvio.mensagem}
                onFechar={() => setForcarEnvio({ show: false, mensagem: '', reenviar: null })}
                onConfirmar={() => {
                    const reenviar = forcarEnvio.reenviar;
                    setForcarEnvio({ show: false, mensagem: '', reenviar: null });
                    if (reenviar) reenviar();
                }}
            />
        </ErpTemplate>
    );
}
